if (!customElements.get('faq-accordion-group')) {
  customElements.define('faq-accordion-group', class extends HTMLElement {
    connectedCallback() {
      this._observer = new MutationObserver(mutations => {
        for (const m of mutations) {
          if (m.target.getAttribute('aria-expanded') === 'true') {
            const opened = m.target.closest('accordion-disclosure');
            for (const acc of this.querySelectorAll(':scope > accordion-disclosure')) {
              if (acc !== opened) acc.close();
            }
            break;
          }
        }
      });
      for (const acc of this.querySelectorAll(':scope > accordion-disclosure')) {
        const d = acc.querySelector('details');
        if (d) this._observer.observe(d, { attributes: true, attributeFilter: ['aria-expanded'] });
      }
    }
    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
    }
  });
}
